import React from 'react'
import Styles from './styles'
import { CardFaqsProps } from '../CardFaqs/CardFaqs'

export const CardResultFaqs = ({
  name,
  body,
  image,
  onClick,
  slug,
  ...props
}: CardFaqsProps) => (
  <Styles.CardResultFaqs
    name={name}
    body={body}
    image={image}
    noOfLinesName={1}
    noOfLinesBody={3}
    slug={slug}
    onClick={onClick}
    {...props}
  />
)
